import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import store from '../state/store';
import routes from './routes' 
import { notify } from '@/helpers/notify' 

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }, 
  options: {
    allowDuplicateRouter: true,
  },
})


const sessionTimeoutSeconds = ((12 * 60) * 60);
let sessionTimer;

// Oturum zaman aşımı işlemi
function startSessionTimer() {
  sessionTimer = setTimeout(() => {
    store.dispatch('authfack/logout')
      location.href="/login"
    }, sessionTimeoutSeconds * 1000); // setTimeout() milisaniye cinsinden çalıştığı için saniyeyi 1000 ile çarpıyoruz
}

// Oturum zaman aşımını yenile
function resetSessionTimer() {
    // eslint-disable-next-line no-console
     //console.log('Yenilendi');
    clearTimeout(sessionTimer); // Önceki zamanlayıcıyı temizle
    startSessionTimer(); // Yeni bir zamanlayıcı başlat
}


// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {

    setInterval(() => {
      if(window.navigator.onLine === false){
        notify.error('İnternet bağlantınızı kontrol ediniz.','center-center',false)
      }
    }, 3000);
   
    //continue to next page
    const publicPages = ['/login',  '/forgot-password',  '/404'];
    const authpage = !publicPages.includes(routeTo.path);
    const loggeduser = localStorage.getItem('token');
     
    if (authpage && !loggeduser) { return next('/login') }

    const userdata = JSON.parse(localStorage.getItem('userdata'))
  
    if (userdata) {
      
      if (authpage && routeTo.path != '/logout'){
        
        store.dispatch('authfack/fetchSettingsIfNeeded')

        document.addEventListener('mousemove', resetSessionTimer);
        document.addEventListener('keypress', resetSessionTimer);
      
        const rolename = userdata.role_name
        const currentRole = routeTo.meta.resource.split('|')
        const abilities = userdata.abilities ?? [];

        if (userdata.role_name == 'dealer') {
          store.dispatch('authfack/fetchBalance')
        }

        if(userdata.role_name != 'admin'){ //admin değilse
          if (abilities.includes(routeTo.name)) {
            next();
            return
          }
        } 
        
        if (!currentRole.includes(rolename)) { router.push({ name: "404" }) }
        
      }
    }
   next();
})



 
router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

export default router
